import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  setSelectOptions,
  setSelectLoading,
  setSelectError,
} from "../../store/doctor/selectOptionsSlice";
import { translations } from "../../helpers";

export const useSelectOptionsStore = () => {
  const dispatch = useDispatch();

  const { protocols, patienSurgeryStates } = useSelector(
    (state) => state.doctor.selectOptions
  );

  const getProtocols = useCallback(async (content) => {
    try {
      dispatch(setSelectLoading({ key: "protocols" }));

      const { data } = await gosafeApi.get(`protocol`);

      // Si hay contenido con protocolId, obtén el texto personalizado
      if (content?.protocolId && content?.id) {
        try {
          const { data: filledText } = await gosafeApi.post(
            `patientSurgery/protocol`,
            content
          );
          const newProtocols = data.map((protocol) =>
            protocol.id === content.protocolId
              ? { ...protocol, text: filledText }
              : protocol
          );
          dispatch(setSelectOptions({ key: "protocols", data: newProtocols }));
          return;
        } catch (error) {
          console.error("Error fetching protocol text:", error);
          // Si falla, usa los datos base sin el texto personalizado
          dispatch(setSelectOptions({ key: "protocols", data }));
          return;
        }
      }

      dispatch(setSelectOptions({ key: "protocols", data }));
      return;
    } catch (error) {
      dispatch(
        setSelectError({
          key: "protocols",
          message:
            translations[error?.response?.data?.message] ||
            error?.response?.data?.message ||
            error?.message,
        })
      );
      return;
    }
  }, [dispatch]);

  return {
    // Props
    protocols,
    patienSurgeryStates,

    // Methods
    getProtocols,
  };
};
